const callbackNorwegian = {
  processing: "Behandler LinkedIn-autorisasjon...",
  verifying: "Verifiserer brukerinformasjon...",
  connecting: "Oppretter sikker tilkobling til LinkedIn...",
  gettingProfile: "Henter profilinformasjon...",
  saving: "Lagrer informasjonen din sikkert...",
  connected: "LinkedIn-konto tilkoblet!",
  loadingSteps: {
    processing: "Behandler autorisasjon",
    connecting: "Oppretter sikker tilkobling",
    profile: "Henter profilinformasjon",
    finishing: "Fullfører integrasjon"
  },
  waitMessage: "Vennligst vent mens vi fullfører integrasjonen med LinkedIn-kontoen din...",
  error: {
    title: "Det oppstod en feil",
    solutions: {
      title: "Mulige løsninger:",
      clearCookies: "Tøm nettleserens informasjonskapsler og hurtiglager",
      tryBrowser: "Prøv en annen nettleser (Chrome eller Firefox anbefales)",
      checkCookies: "Forsikre deg om at du ikke har blokkert informasjonskapsler fra LinkedIn",
      useHttps: "Prøv å åpne app.nuvik.io direkte via HTTPS"
    },
    backButton: "Tilbake til innstillinger"
  },
  success: {
    title: "LinkedIn-konto tilkoblet!",
    message: "LinkedIn-kontoen din er nå tilkoblet Nuvik.io.",
    redirect: "Du vil bli omdirigert automatisk..."
  }
};

export default callbackNorwegian; 